import { makeStyles } from 'tss-react/mui';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { OrderInfo } from 'adoms-common-lib';
import React from 'react';
import { BusinessDestinationInfo } from 'adoms-common-lib/build/model/OrderInfo/BusinessDestinationInfo';


const useStyles = makeStyles()((theme) => ({
    paper: {
        padding: '12px',
        textAlign: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
    },
}));


/**
 * 受け取り人情報を表示する
 * @param props order
 */
export default function BusinessOrderDestinationInfo(props: any) {
    const { classes } = useStyles();
    const order = props.order as OrderInfo;
    const OrderDestinationInfo = props.order.destination as BusinessDestinationInfo
    return (
        <div>
            <Paper className={classes.paper} elevation={0}>
                <Typography variant="h5" component="div">
                    {OrderDestinationInfo.companyName} <br /> {OrderDestinationInfo.lastname} {OrderDestinationInfo.firstname}様
                </Typography>
                <Typography variant="body1" component="div">
                    メールアドレス：{OrderDestinationInfo.mailaddress !== "" ? OrderDestinationInfo.mailaddress : "***"}
                </Typography>
                <Typography variant="body1" component="div">
                    電話番号：{OrderDestinationInfo.tel !== "" ? OrderDestinationInfo.tel : "***"}
                </Typography>
            </Paper>
        </div>
    );

}